import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCheckmark2"><Path fillRule="evenodd" clipRule="evenodd" d="M22.7481 3.73706L9.23765 22.0325L1.24408 15.7042L2.79584 13.7441L8.76238 18.4676L20.737 2.25195L22.7481 3.73706Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark2;
